<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema } from '@bagelink/vue'
const schema = defineSchema({})
export const SymposiumContributors = defineBlock({
	thumbnail: '/block-thumbs/SymposiumContributors.svg',
	category: 'Content',
	order: 400,
	name: 'SymposiumContributors',
	label: 'Symposium Contributors',
	icon: 'groups',
	schema,
})
</script>
<script setup lang="ts">


import { computed } from 'vue'
import AuthorSmallLink from '@/components/blocks/AuthorSmallLink.vue'
import { sanitizeArticleTitleHtml } from '@/utils/articleHtml'
import { useBoundPageModel } from '@/composables/useBoundPageItem'



const previewRecord = { _id: 'preview-symposium' }
const previewArticles = [
	{
		_id: 'preview-contribution',
		symposiumId: 'preview-symposium',
		title: 'A Sample Response',
		slug: 'sample-response',
		author: { name: 'Sample Contributor', slug: 'sample-contributor', image: '/webclip.png' },
	},
]

function normalizeContributors(record: Record<string, any>) {
	const source = record._id === previewRecord._id ? previewArticles : record._ssgArticles ?? []
	return source
		.filter((article: any) => article.symposiumId === record._id)
		.sort((a: any, b: any) => (a.seriesOrder ?? 999) - (b.seriesOrder ?? 999))
		.map((article: any, index: number) => {
			const author = article.authors?.[0] || article.author || null
			return {
				id: article._id || index,
				title: article.title || '',
				author: author?.name || '',
				authorImage: author?.image || '',
				authorLink: author?.slug ? `/author/${author.slug}` : '',
				name: author?.title || '',
				link: article.slug ? `/article/${article.slug}` : '',
			}
		})
}

const model = useBoundPageModel(normalizeContributors, previewRecord)
const contributors = computed(() => model.value ?? [])
</script>

<template>
	<div v-if="contributors.length" class="pt-3 pb-2 m_px-1 w720px mx-auto">
		<h2 class="txt30 regular m-0 line-height-12 balance pb-05">Contributors</h2>

		<div
			v-for="contributor in contributors"
			:key="contributor.id"
			class="border-top block py-1 decoration-none"
		>
			<RouterLink :to="contributor.link" class="decoration-none block">
				<p class="txt18 pb-05" v-html="sanitizeArticleTitleHtml(contributor.title)" />
			</RouterLink>
			<AuthorSmallLink
				:title="contributor.name"
				:name="contributor.author"
				:image="contributor.authorImage"
				:link="contributor.authorLink"
				:show-image="true"
			/>
		</div>
	</div>
</template>
